import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="py-24" style={{ background: "var(--ps-cream)" }} data-testid="not-found">
      <div className="mx-auto max-w-2xl px-4 sm:px-6 text-center">
        <p className="font-display uppercase tracking-[0.3em] text-[var(--ps-red)] text-sm">Errore 404</p>
        <h1 className="section-title mt-4 text-4xl sm:text-5xl lg:text-6xl">Pagina non trovata</h1>
        <p className="mt-4 text-[var(--ps-ink-soft)] text-lg">La pagina che stai cercando non esiste o è stata spostata.</p>
        <Link to="/" className="ps-btn ps-btn-primary mt-8" data-testid="not-found-home">
          Torna alla Home
        </Link>
      </div>
    </section>
  );
}
